(window.webpackJsonp=window.webpackJsonp||[]).push([[586],{
/***/Cndk:
/***/function(t,e,i){"use strict";
// EXTERNAL MODULE: ./node_modules/lit-element/lit-element.js?babel-target=es6 + 3 modules
var a=i("Rukz"),s=i("H/aU"),o=i("6Ted"),n=i("Mprp"),r=i("c1TX"),c=i("Z5xp"),l=i("Jb6u"),h=i("DQGw"),d=i("xD8C"),p=i("bZUI"),m=i("3xkH"),u=i("yEz4"),b=(i("bYSI"),i("1sm3"),i("fbHz"),i("vBTZ"),i("RXvc"),i("OLad"),i("dVtU"),i("+Z0c"),i("LAU/"),i("zU76")),g=i("8z/O"),_=i("hR6X"),f=(i("3teY"),i("OBAu"),i("r7YR"),i("VBvb"),i("6Bdj")),k=i("4fQY"),x=i("CNe1"),w=i("js+h"),v=i("vcFs");
// EXTERNAL MODULE: ./node_modules/@polymer/polymer/lib/utils/settings.js?babel-target=es6
// CONCATENATED MODULE: ./src/views/404-view.js?babel-target=es6
// These are the shared styles needed by this element.
class y extends x.a{static get styles(){return[_.a,_.Db,a.c`
        :host {
          display: block;
          height: 100vh;
          overflow: hidden;
        }

        .floating-elements {
          position: absolute;
          width: 100%;
          height: 100%;
          overflow: hidden;
          pointer-events: none;
        }

        .floating-element {
          position: absolute;
          opacity: 0.1;
          animation: float 20s infinite linear;
        }

        .floating-element img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          object-position: center;
          transform-origin: center center;
          backface-visibility: hidden;
          -webkit-backface-visibility: hidden;
        }

        .floating-element:nth-child(1) {
          top: 10%;
          left: 10%;
          animation-delay: 0s;
        }

        .floating-element:nth-child(2) {
          top: 20%;
          right: 10%;
          animation-delay: 3s;
        }

        .floating-element:nth-child(3) {
          top: 60%;
          left: 20%;
          animation-delay: 6s;
        }

        .floating-element:nth-child(4) {
          top: 70%;
          right: 20%;
          animation-delay: 9s;
        }

        .floating-element:nth-child(5) {
          top: 30%;
          left: 70%;
          animation-delay: 12s;
        }

        @keyframes float {
          0% {
            transform: translateY(100vh) rotate(0deg);
            opacity: 0.1;
          }
          10% {
            opacity: 0.1;
          }
          85% {
            opacity: 0.1;
          }
          98% {
            opacity: 0.05;
          }
          100% {
            transform: translateY(-100px) rotate(360deg);
            opacity: 0;
          }
        }

        @keyframes bounce {
          0%,
          20%,
          50%,
          80%,
          100% {
            transform: translateY(0);
          }
          40% {
            transform: translateY(-10px);
          }
          60% {
            transform: translateY(-5px);
          }
        }

        @keyframes pulse {
          0% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.05);
          }
          100% {
            transform: scale(1);
          }
        }

        .error-number {
          background: linear-gradient(135deg, var(--app-secondary-color) 0%, var(--app-primary-color) 100%);
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          animation: pulse 2s infinite;
        }

        .bounce-btn {
          animation: bounce 2s infinite;
        }

        .glass-effect {
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.2);
        }

        .gradient-bg {
          background: linear-gradient(135deg, var(--app-secondary-color) 0%, var(--app-primary-color) 100%);
        }

        .btn-primary {
          background-color: var(--app-secondary-color);
          border-color: var(--app-secondary-color);
        }

        .btn-primary:hover {
          background-color: var(--app-primary-color);
          border-color: var(--app-primary-color);
        }
      `]}_goHome(){window.location.hash="#/home"}_goBack(){window.history.back()}render(){return a.d`
      <div class="gradient-bg min-h-screen relative flex items-center justify-center overflow-hidden">
        <!-- Floating Background Elements -->
        <div class="floating-elements">
          ${"rekeep"==v.a?a.d`
                <div class="floating-element" style="width: 80px; height: 80px;">
                  <svg viewBox="0 0 100 100" fill="white" opacity="0.8">
                    <rect x="10" y="15" width="80" height="75" rx="8" fill="white" />
                    <circle cx="50" cy="55" r="25" fill="rgba(0,0,0,0.4)" />
                    <circle cx="50" cy="55" r="20" fill="rgba(0,0,0,0.2)" />
                    <circle cx="25" cy="25" r="3" fill="rgba(0,0,0,0.6)" />
                    <circle cx="35" cy="25" r="3" fill="rgba(0,0,0,0.6)" />
                    <rect x="50" y="20" width="30" height="8" rx="2" fill="rgba(0,0,0,0.4)" />
                  </svg>
                </div>
                <div class="floating-element" style="width: 64px; height: 64px;">
                  <svg viewBox="0 0 100 100" fill="white" opacity="0.8">
                    <rect x="10" y="15" width="80" height="75" rx="8" fill="white" />
                    <circle cx="50" cy="55" r="25" fill="rgba(0,0,0,0.4)" />
                    <circle cx="50" cy="55" r="20" fill="rgba(0,0,0,0.2)" />
                    <circle cx="25" cy="25" r="3" fill="rgba(0,0,0,0.6)" />
                    <circle cx="35" cy="25" r="3" fill="rgba(0,0,0,0.6)" />
                    <rect x="50" y="20" width="30" height="8" rx="2" fill="rgba(0,0,0,0.4)" />
                  </svg>
                </div>
                <div class="floating-element" style="width: 48px; height: 48px;">
                  <svg viewBox="0 0 100 100" fill="white" opacity="0.8">
                    <rect x="10" y="15" width="80" height="75" rx="8" fill="white" />
                    <circle cx="50" cy="55" r="25" fill="rgba(0,0,0,0.4)" />
                    <circle cx="50" cy="55" r="20" fill="rgba(0,0,0,0.2)" />
                    <circle cx="25" cy="25" r="3" fill="rgba(0,0,0,0.6)" />
                    <circle cx="35" cy="25" r="3" fill="rgba(0,0,0,0.6)" />
                    <rect x="50" y="20" width="30" height="8" rx="2" fill="rgba(0,0,0,0.4)" />
                  </svg>
                </div>
                <div class="floating-element" style="width: 96px; height: 96px;">
                  <svg viewBox="0 0 100 100" fill="white" opacity="0.8">
                    <rect x="10" y="15" width="80" height="75" rx="8" fill="white" />
                    <circle cx="50" cy="55" r="25" fill="rgba(0,0,0,0.4)" />
                    <circle cx="50" cy="55" r="20" fill="rgba(0,0,0,0.2)" />
                    <circle cx="25" cy="25" r="3" fill="rgba(0,0,0,0.6)" />
                    <circle cx="35" cy="25" r="3" fill="rgba(0,0,0,0.6)" />
                    <rect x="50" y="20" width="30" height="8" rx="2" fill="rgba(0,0,0,0.4)" />
                  </svg>
                </div>
                <div class="floating-element" style="width: 72px; height: 72px;">
                  <svg viewBox="0 0 100 100" fill="white" opacity="0.8">
                    <rect x="10" y="15" width="80" height="75" rx="8" fill="white" />
                    <circle cx="50" cy="55" r="25" fill="rgba(0,0,0,0.4)" />
                    <circle cx="50" cy="55" r="20" fill="rgba(0,0,0,0.2)" />
                    <circle cx="25" cy="25" r="3" fill="rgba(0,0,0,0.6)" />
                    <circle cx="35" cy="25" r="3" fill="rgba(0,0,0,0.6)" />
                    <rect x="50" y="20" width="30" height="8" rx="2" fill="rgba(0,0,0,0.4)" />
                  </svg>
                </div>
              `:a.d`
                <img src="${w.a}" class="floating-element" style="width: 50px; height: 50px;" alt="icon" />
                <img src="${w.a}" class="floating-element" style="width: 70px; height: 70px;" alt="icon" />
                <img src="${w.a}" class="floating-element" style="width: 90px; height: 90px;" alt="icon" />
                <img src="${w.a}" class="floating-element" style="width: 110px; height: 110px;" alt="icon" />
                <img src="${w.a}" class="floating-element" style="width: 130px; height: 130px;" alt="icon" />
              `}
        </div>

        <!-- Main Content -->
        <div class="text-center z-10 px-6 max-w-4xl mx-auto">
          <!-- Error Message Card -->
          <div class="glass-effect rounded-2xl p-8 mb-8 text-white">
            <div class="mb-6">
              <!-- Error Icon -->
              <svg class="w-20 h-20 mx-auto mb-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                  clip-rule="evenodd"
                ></path>
              </svg>
            </div>

            <h2 class="text-3xl md:text-4xl font-bold mb-4">404 - ${this.sxTranslate("FUNCTION_NOT_AVAILABLE")}</h2>

            <p class="text-sm md:text-xl text-gray-200 mb-6 leading-relaxed">
              ${this.sxTranslate("NOT_FOUND_INFO_ONE")}
              <br class="hidden md:block" />
              ${this.sxTranslate("NOT_FOUND_INFO_TWO")}
            </p>

            <!-- Suggestions -->
            <div class="text-left max-w-md mx-auto mb-6">
              <p class="text-sm text-gray-300 mb-3 font-semibold">${this.sxTranslate("NOT_FOUND_OPTIONS")}</p>
              <ul class="text-sm text-gray-300 space-y-2">
                <li class="flex items-center">
                  <svg class="w-4 h-4 mr-2 text-green-400" fill="currentColor" viewBox="0 0 20 20">
                    <path
                      fill-rule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                  ${this.sxTranslate("NOT_FOUND_OPTION_ONE")}
                </li>
                <li class="flex items-center">
                  <svg class="w-4 h-4 mr-2 text-green-400" fill="currentColor" viewBox="0 0 20 20">
                    <path
                      fill-rule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                  ${this.sxTranslate("NOT_FOUND_OPTION_TWO")}
                </li>
                <li class="flex items-center">
                  <svg class="w-4 h-4 mr-2 text-green-400" fill="currentColor" viewBox="0 0 20 20">
                    <path
                      fill-rule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                  ${this.sxTranslate("NOT_FOUND_OPTION_THREE")}
                </li>
              </ul>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button
              @click="${this._goHome}"
              class="bounce-btn btn-primary text-white px-8 py-4 rounded-full font-semibold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 flex items-center space-x-2"
            >
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                <path
                  d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
                ></path>
              </svg>
              <span>Home</span>
            </button>

            <button
              @click="${this._goBack}"
              class="bg-transparent border-2 border-white text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-white hover:text-gray-800 transform hover:scale-105 transition-all duration-200 flex items-center space-x-2"
            >
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" style="transform: translateY(-2px);">
                <path
                  fill-rule="evenodd"
                  d="M7.707 14.707a1 1 0 01-1.414 0L2.586 11H17a1 1 0 110 2H2.586l3.707 3.707a1 1 0 01-1.414 1.414l-5.414-5.414a1 1 0 010-1.414L5.293 6.879a1 1 0 011.414 1.414L3 12h14a1 1 0 110 2H3l3.707 3.707z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              <span>${this.sxTranslate("BACK")}</span>
            </button>
          </div>
        </div>
      </div>
    `}}window.customElements.define("six-404-view",y);
// EXTERNAL MODULE: ./src/services/api-ajax.js?babel-target=es6
var O=i("nIeH"),j=i("N+pe"),$=i("fpEW");
// EXTERNAL MODULE: ./src/directives/six-utils.js?babel-target=es6
// CONCATENATED MODULE: ./src/views/dottor-frederick-frankenstein.js?babel-target=es6
const C=a.d` <six-404-view></six-404-view> `,S=Object(_.zb)();class T extends(Object(o.a)(h.a)(x.a)){static get styles(){return[_.a]}render(){const t=["login","default","view404","customerorder-automatic-approval","ddt-mobile/","endowment/mobile/"].some(t=>this._page.includes(t));return a.d`
      ${S}
      ${this._menu&&!t?a.d`
            <six-menu
              customer="${this._appTitle}"
              class="slide-menu-container ${this._drawerOpened?"open":""}"
              width="356px"
              handleBookmarks
              ?isopen="${!!this._drawerOpened}"
              showMenu
              showSearch
              .items="${this._menu}"
              .bookmarks="${this._bookmarks}"
              @bookmark-remove="${this._removeBookmark}"
              @navigate="${this._menuNavigate}"
              @bookmark-add="${this._addBookmark}"
              @menuUpdate="${this._menuUpdate}"
              @discardedBookmarks="${this._handleBookmarksDiscard}"
              @pinnedMenu="${t=>this._pinnedMenu(t)}"
            ></six-menu>
          `:k.g}

      <!-- Header -->
      ${t?k.g:a.d`
            ${this._drawerOpened&&this._menuByObject&&"vertical"===this._orientation?k.g:a.d`
                  <tab-menu
                    orientation="${this._orientation}"
                    .menuByObject="${this._menuByObject}"
                    page="${this._page}"
                    .bookmarks="${this._bookmarks}"
                    @tabSelect="${t=>this._loadPage(t.detail.value)}"
                  >
                  </tab-menu>
                `}
          `}
      ${t?k.g:a.d`
            <top-bar
              @tabSelect="${t=>this._loadPage(t.detail.value)}"
              @menuVoiceClick="${this._onMenuVoiceClick}"
              @buttonClicked="${this._toggleMenuVisibility}"
              ?advancedMenu="${this._auth.options&&this._auth.options.admin}"
              @changeSearch="${t=>this._loadPage(t.detail.value)}"
              @result="${t=>this._micResult(t)}"
              .menu="${this._menu}"
              .username="${this._username}"
              .role=${this._role}
              .company="${this._company}"
              .bookmarks="${this._bookmarks}"
              workstationCode="${this._workstationCode}"
              appTitle="${this.appTitle}"
              page="${this._page}"
              .pwaMode="${this._pwaMode}"
              .notificationWebsocketUrl="${this._notificationWebsocketUrl}"
              @notification-read="${this._notificationRead}"
              notificationsCount="${this._notificationsCount}"
              .notifications="${this._notifications}"
              complaintsCount="${this._complaintsCount}"
              .complaints="${this._complaints}"
              websocketStatus="${this._websocketStatus}"
              @reconnectWebSocket="${this._reconnectWebSocket}"
              ?showUnderstockPercentageAlert="${this._showUnderstockPercentageAlert}"
              style="position: sticky; z-index: 99; width: 100%; top: 0;"
              @closeWebSocket="${this._closeWebSocket}"
              ?disableWebsocket="${this._disableWebsocket}"
            >
            </top-bar>
            <iframe id="jsfFrame" style="display:none;" frameborder="0"></iframe>
          `}

      <!-- Main content -->
      <main
        role="main"
        class="main-content ${"login"==this._page||this._page.includes("endowment/mobile")||this._page.includes("ddt-mobile")?"no-margin":""}"
      >
        ${Object(u.d)(C)}
        <six-websocket-listener
          auto
          @websocket-message=${this._onReadEvent}
          @status-notify=${this._onReadStatus}
          id="webSocketListener"
          url="${this._wsUrl}"
          milliseconds
        ></six-websocket-listener>
        <six-message .position="${this._position}"></six-message>
      </main>
      <six-new-spinner id="globalSpinnerSixlm"></six-new-spinner>
      <snack-bar ?active="${this._snackbarOpened}"> You are now ${this._offline?"offline":"online"}. </snack-bar>
    `}static get properties(){return{appTitle:{type:String},
//private properties
_bookmarks:{reflect:!1,attribute:!1},_page:{reflect:!1,attribute:!1},_drawerOpened:{attribute:!1},_menu:{attribute:!1},_authToken:{attribute:!1},_wsUrl:{attribute:!1},_notificationWebsocketUrl:{attribute:!1},_role:{attribute:!1},_company:{attribute:!1},_position:{attribute:!1},_menuByObject:{type:Object},_notificationsCount:{type:String},_notifications:{type:Array},_complaintsCount:{type:String},_complaints:{type:Array},_websocketStatus:{attribute:!1},_showUnderstockPercentageAlert:{attribute:!1},_disableWebsocket:{attribute:!1}}}constructor(){super();this._apiCommon=new b.a;try{if(sessionStorage.authData){h.a.dispatch(Object(d.g)(JSON.parse(sessionStorage.authData)));const t=JSON.parse(localStorage.workstation||JSON.stringify(null));t&&h.a.dispatch(Object(d.j)(t)),O.b.defaultHeaders={"auth-token":Object(p.e)(h.a.getState()),"auth-id":Object(p.c)(h.a.getState()),"auth-workstation":Object(p.u)(h.a.getState())}}}catch(t){console.warn("sessionStorage not available:",t.message)}const t=Object(j.s)(Object(j.g)());//set global locale for moment.js
// eslint-disable-next-line no-console
if(console.log("Current Locale: "+t),v.d)
// eslint-disable-next-line no-console
console.log("B:v1.11.0_serviziospedalieri_R:fea215d9ded3ef003f5d820e9e6c3ef9b6c10393_CI:_P:_2026-05-19T07:54:33.742Z");else{this._userId=Object(p.r)(h.a.getState());//inizializzazione menu
const t=[...Object(p.n)(h.a.getState())],[,e]=this._indexMenu(t,{},{},"root");h.a.dispatch(Object(m.G)(e));const i=location.protocol.replace("http","ws");//http -> ws, https-> wss
this._notificationWebsocketUrl=`${i}//${location.host}/api/ws`,this._menuByObject={},this._notifications=[],this._websocketStatus=""}// To force all event listeners for gestures to be passive.
// See https://www.polymer-project.org/3.0/docs/devguide/settings#setting-passive-touch-gestures
Object(s.m)(!0),this._setI18nConfig();const e=["ddt-mobile/","endowment/mobile/","customerorder-automatic-approval"].some(t=>location.hash.slice(2).includes(t));if(this._appTitle=v.b,this._orientation="steriliza"==this._appTitle?"horizontal":"vertical",Object(c.a)(t=>h.a.dispatch(Object(u.c)(decodeURI(t.hash.slice(2))))),e)h.a.dispatch(Object(u.c)(location.hash.slice(2)));else try{const t="undefined"!=typeof sessionStorage;!1===v.d||t&&sessionStorage.authData?location.hash&&"#/"!=location.hash||h.a.dispatch(Object(u.c)("home")):h.a.dispatch(Object(u.c)("login"))}catch(t){console.warn("sessionStorage check failed:",t.message),h.a.dispatch(Object(u.c)("login"))}}shouldUpdate(t){return this._translationLoaded&&super.shouldUpdate(t)}firstUpdated(){this.globalSpinnerSixlm=this.shadowRoot.querySelector("#globalSpinnerSixlm"),h.a.dispatch(Object(m.B)(this.globalSpinnerSixlm)),Object(r.a)(t=>h.a.dispatch(Object(m.L)(t))),Object(n.a)("(min-width: 460px)",()=>h.a.dispatch(Object(m.K)(!1))),this._ws=this.shadowRoot.querySelector("#webSocketListener"),this.removeAttribute("unresolved"),this._inputSearch=this.shadowRoot.getElementById("inputSearch"),setInterval(()=>{this._ws&&this._ws.keepAlive()},3e4)}updated(t){if(t.has("_authToken"))if(this._authToken&&this._authToken.length){O.b.defaultHeaders={
//decoro tutte le chiamate che partono dalla classe Ajax con gli headers di default
"auth-token":this._authToken,"auth-id":this._authId,"auth-workstation":this._workstationCode};const t=Object(j.s)(Object(j.g)());//update global locale for moment.js
// eslint-disable-next-line no-console
console.log("Current Locale: "+t),//FIXME:la ws viene impostata quando cambio la lookup nella pagina di login, quindi si può togliere da qui
//this._getWorkstation();
this._initBookmarks(this._authId),this._getToastMessagePosition(),this._getSysPar();const e=location.protocol.replace("http","ws");//http -> ws, https-> wss
this._notificationWebsocketUrl=`${e}//${location.host}/api/ws`,this._apiCommon.getMatrixParValue("jasper.report.parentFolderUri").then(t=>{h.a.dispatch(Object(m.D)(t))}).catch(()=>{this.errorMessage("CANNOT_LOAD_MATRIXPAR")}),this._apiCommon.getMatrixParValue("jasper.report.userPassword").then(t=>{h.a.dispatch(Object(m.F)(t))}),this._apiCommon.getMatrixParValue("jasper.report.contextPath").then(t=>{h.a.dispatch(Object(m.C)(t))}),this._apiCommon.getMatrixParValue("jasper.report.reportAllowed","").then(t=>{h.a.dispatch(Object(m.E)(t.replaceAll(/\s+/g,"").split(",")))}),this._apiCommon.getMatrixParBoolValue("endowmentService.isAgreementItemParent","false").then(t=>{h.a.dispatch(Object(m.x)(t))}),this._apiCommon.getMatrixParBoolValue("app.showUnderstockPercentageAlert").then(t=>{this._showUnderstockPercentageAlert=t}),this._apiCommon.getMatrixParBoolValue("six.disableWebsocketSelector",!1).then(t=>this._disableWebsocket=t);// retrieve all child menu items (they are under children and under items)
const i=this._menu.filter(t=>t&&(t.children&&t.children.length||t.items&&t.items.length)).reduce((t,e)=>(e.children&&e.children.length&&t.push(...e.children.map(t=>t.code)),e.items&&e.items.length&&t.push(...e.items.map(t=>t.code)),t),[]);h.a.dispatch(Object(m.H)(i))}else O.b.defaultHeaders={},Object(j.f)()}stateChanged(t){this._page=Object(f.p)(t),this._offline=Object(f.o)(t),this._snackbarOpened=Object(f.s)(t),this._drawerOpened=Object(f.f)(t),this._workstationCode=Object(p.u)(t),this._wsUrl=Object(p.t)(t),this._bookmarks=Object(p.h)(t),this._pwaMode=Object(p.o)(t),this._websocketStatus=Object(f.t)(t),this._menu=Object(p.n)(t),this._auth=Object(p.b)(t),this._authToken=Object(p.e)(t),this._authId=Object(p.c)(t),this._userId=Object(p.r)(t);const e=this._auth.profile,i=e&&e.description||"",a=e&&e.items&&e.items[0]&&e.items[0].description||"";this._role=Object(p.d)(t),this._username={name:this._auth.info.name,surname:this._auth.info.surname,user:this._auth.authId},this._company={company:i,division:a};const s=`${this.appTitle} - ${this._page}`;Object(l.a)({title:s,description:s});let o=Object(p.f)(t),n=Object(p.l)(t);if(this._authId&&this._authToken&&o&&n){let t=this.shadowRoot.querySelector("#jsfFrame");t&&!t.src&&(t.src="/six/loginPortal.jsp?authId="+this._authId+"&authToken="+this._authToken+"&functionCode=&selectedId=&code="+(null==this._workstationCode?"":"&workstation="+this._workstationCode)+(o?"&azCod="+o:"")+(n?"&divCod="+n:""),this.requestUpdate())}}
/********************************************************************************************************** */_setI18nConfig(){Object(g.b)({loader:async t=>{let e={},i=await fetch("assets/i18n/generated/en.json?_="+(new Date).getTime());return i.status>=200&&i.status<300?(e=await i.json(),i=await fetch(`assets/i18n/generated/${t}.json?_=${(new Date).getTime()}`),i.status>=200&&i.status<300&&($.a.merge(e,await i.json()),i=await fetch(`assets/i18n/generated/${v.a}.${t}.json?_=${(new Date).getTime()}`),i.status>=200&&i.status<300&&$.a.merge(e,await i.json()))):this.errorMessage("CANNOT_LOAD_TRANSLATIONS"),v.d||(i=await fetch("assets/i18n/labels.json?_="+(new Date).getTime()),i.status>=200&&i.status<300&&$.a.merge(e,await i.json())),e},lookup:function(t,e){if(null!=t){const i=t.split(".").map(t=>t.toUpperCase());let a,s=e.strings;for(;null!=s&&i.length>0;)s=i.shift(),a=a?a[s]:e.strings[s];return a}return null},interpolate:(t,e)=>{let i=t;return e.forEach((t,e)=>i=i.replace(new RegExp(`\\{${e}\\}`,"gi"),t)),i},empty:t=>""+t});let t=Object(j.g)();try{t=t.split("-").shift().toLowerCase()}catch{t="en",// eslint-disable-next-line no-console
console.log("could not set translation labels for lang:"+Object(j.g)())}Object(g.c)(t).then(()=>{this._translationLoaded=!0,this.requestUpdate()})}_getNotifiesCount(){this._apiCommon.getUnhandledMessage().then(t=>{this._notificationsCount=t.totalResults,this._notifications=t.list}).catch(()=>{this._notifications=[],this._notificationsCount=0}),this._apiCommon.getUnhandledTickets().then(t=>{this._complaintsCount=t.totalResults,this._complaints=t.list}).catch(()=>{this._complaints=[],this._complaintsCount=0})}_menuNavigate(t){this._loadPage(t.detail.value.code)}_getWorkstation(){this._apiCommon.getWorkstation(this._workstationCode).then(t=>{h.a.dispatch(Object(d.j)(t))},t=>{
// eslint-disable-next-line no-console
console.log(t)})}async _initBookmarks(t){let e=[];const i=await this._apiCommon.getBookmarks(t).catch(()=>!1),[,a]=this._indexMenu(this._menu,{},{},"root");if(this._menuByObject=a,i&&i.bookmarks&&i.bookmarks.length)e=i.bookmarks;else{console.log("Fallbacking to group bookmarks");const t=await this._apiCommon.userProfile(this._userId).catch(()=>[]);if(t&&t.list&&t.list.length&&t.list[0].type_id){const i="group-"+t.list[0].type_id,a=await this._apiCommon.getBookmarks(i).catch(()=>[]);a&&a.bookmarks&&a.bookmarks.length&&(e=a.bookmarks)}}let s=e.filter(t=>a[t.code]);h.a.dispatch(Object(m.G)(a)),h.a.dispatch(Object(d.h)([...s]))}_toggleMenuVisibility(){h.a.dispatch(Object(m.K)(!Object(f.f)(h.a.getState())))}
/**
   * Evento scatenato alla lettura di un barcode.
   * @param {*} e
   */_onReadEvent(t){h.a.dispatch(Object(m.y)(t.detail.value))}_loadPage(t){if(t.startsWith("?jsf")){let e=t.replace(/.*{/g,"").replace(/}.*/g,"");h.a.dispatch(Object(u.c)("jsf/"+encodeURIComponent(e)))}else h.a.dispatch(Object(u.c)(t))}_micResult(t){const e=t.detail,i=e.completeTranscript;this._inputSearch.value=i.toLowerCase(),e.isFinal&&h.a.dispatch(Object(u.c)(""+i.toLowerCase()))}_onMenuVoiceClick(t){switch(t.detail.key){case"logout":this.shadowRoot.querySelector("top-bar").closeWebsocket(),this._logout();break;case"admin":this._loadPage("administrator");break;case"preferences":h.a.dispatch(Object(u.c)("preferences"))}}_logout(){try{"undefined"!=typeof sessionStorage&&delete sessionStorage.authData}catch(t){console.warn("sessionStorage not available during logout:",t.message)}if(h.a.dispatch(Object(d.f)()),v.d){let t=document.createElement("form");t.setAttribute("action","/"),t.setAttribute("method","GET"),document.body.appendChild(t),t.submit()}else h.a.dispatch(Object(u.c)("login"))}_notificationRead(t){const e=t.detail.value,i=JSON.parse(e&&e.metadata||null);if(!e||!i)return void this.errorMessage("OPERATION_FAILED");const a={area:e.area,notificationId:""+i.notificationId,productId:""+i.productId};this._apiCommon.ajax("/api/ict/six/rest/ferri/notification/read","POST",a)}_addBookmark(t){const e=t.detail.value;let i;this._bookmarks.some(t=>{if(e.code===t.code)return i=!0,!0}),i||(this._bookmarks.push({...e,description:e.description}),h.a.dispatch(Object(d.h)([...this._bookmarks])),this._apiCommon.storeBookmarks({bookmarks:this._bookmarks}))}_removeBookmark(t){const e=t.detail.value,i=[];this._bookmarks.some(t=>{e.code!==t.code&&i.push(t)}),h.a.dispatch(Object(d.h)([...i])),this._apiCommon.storeBookmarks({bookmarks:i})}_menuUpdate(t){const e=t.detail.value;h.a.dispatch(Object(d.h)([...e])),this._apiCommon.storeBookmarks({bookmarks:e})}_indexMenu(t={},e={},i,a=null){const s=t;return"root"===i&&(t={}),Object.values(s).map(s=>{t[s.code]={code:s.code,description:s.description,icon:s.icon,items:{}},e[s.code]||(e[s.code]={}),e[s.code]={parentName:i,icon:s.icon,description:s.description},s.children&&(Object.keys(s.children).map(e=>{const i=s.children[e];t[s.code].items[i.code]=i}),this._indexMenu(t[s.code].items,e,s.code,a))}),[t,e]}async _getToastMessagePosition(){const t=await this._apiCommon.ajax("/api/q/matrix/toast.position","POST").onlyResult();this._position=t&&t.value?t.value:"top-end"}_pinnedMenu(t){h.a.dispatch(Object(m.I)(t.detail.value.pinnedMenu))}_getSysPar(){this._apiCommon.getSysPar().then(t=>{h.a.dispatch(Object(d.i)(t.list))}).catch(()=>{this.errorMessage("ERROR_WHILE_LOADING_SYSTEM_PARAMETERS")})}_onReadStatus(t){h.a.dispatch(Object(m.z)(t.detail.status))}_reconnectWebSocket(){this._ws.reconnectWebSocket()}_closeWebSocket(){this._ws.closeWebsocket()}}window.customElements.define("dottor-frederick-frankenstein",T)}}]);